import React from 'react'
import { isClient } from '../../../../helpers'
import { RelatedFields, SelectValue, withParsedContext } from '../../withJSSContext'

interface Props {
  pageEditing: boolean

  parsedFields: {
    name: string
    channel: string
    language: string
    template: string
    guid: string
    platform: string
    status: string
  }

  parsedRouteFields: {
    'Story ID': string
    'Related Departments': RelatedFields[]
    'Story Type': SelectValue[]
    'Story Category': SelectValue[]
  }
}

const MagazinesStoryDetailAnalytics: React.FC<Props> = ({ parsedFields, pageEditing, parsedRouteFields }) => {
  const storyTypeFields = parsedRouteFields?.['Story Type'] || []
  const storyCategoryFields = parsedRouteFields?.['Story Category'] || []
  const pageDepartments = parsedRouteFields?.['Related Departments'] || []

  if (isClient && !pageEditing) {
    window.AnalyticsDataLayer = window.AnalyticsDataLayer || {}
    window.AnalyticsDataLayer.page = window.AnalyticsDataLayer.page || {}
    window.AnalyticsDataLayer.page.content = window.AnalyticsDataLayer.page?.content || {}
    window.AnalyticsDataLayer.user = window.AnalyticsDataLayer.user || {}
    window.AnalyticsDataLayer.platform = window.AnalyticsDataLayer.platform || {}

    window.AnalyticsDataLayer.page.name = parsedFields?.['name']
    window.AnalyticsDataLayer.page.channel = parsedFields?.['channel']
    window.AnalyticsDataLayer.page.language = parsedFields?.['language']
    window.AnalyticsDataLayer.page.template = parsedFields?.['template']
    window.AnalyticsDataLayer.page.department =
      pageDepartments.map((field: RelatedFields) => field?.title).join('; ') || ''

    window.AnalyticsDataLayer.page.content.id = parsedRouteFields?.['Story ID']
    window.AnalyticsDataLayer.page.content.type =
      storyTypeFields.map((field: SelectValue) => field?.key).join(', ') || ''
    window.AnalyticsDataLayer.page.content.category =
      storyCategoryFields.map((field: SelectValue) => field?.key).join(', ') || ''

    window.AnalyticsDataLayer.user.GUID = parsedFields?.['guid']
    window.AnalyticsDataLayer.user.status = parsedFields?.['status']

    window.AnalyticsDataLayer.platform.name = parsedFields?.['platform']
  }

  return null
}

export default withParsedContext(MagazinesStoryDetailAnalytics as React.FC)
